import styled from 'styled-components';

const Label = styled.div`
  font-weight: 500;
  font-size: 13px;
  margin-left: 6px;
`;

export const LabelDescription = styled.p`
  margin-left: 6px;
  font-size: 13px;
  margin-top: 5px;
  color: #595c79;
`;

export default Label;
